/* =========================================================
   MNR HOME SECTIONS  |  assets/mnr-home.js
   - Draws highlight underlines/circles when a section scrolls into view
   - Timeline slider (arrows, dots, progress line, swipe)
   Re-inits inside the Shopify theme editor.
   ========================================================= */
(function () {
  'use strict';

  /* ---------- highlight draw on scroll ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-inview'); io.unobserve(e.target); }
    });
  }, { threshold: 0.25 }) : null;

  function initAnimate(scope) {
    (scope || document).querySelectorAll('.mnr-h.is-animate').forEach(function (el) {
      if (el.__mnrAnim) return; el.__mnrAnim = true;
      if (io && !window.Shopify?.designMode) io.observe(el); else el.classList.add('is-inview');
    });
  }

  /* ---------- timeline ---------- */
  function initTimeline(root) {
    if (!root || root.__mnrTl) return; root.__mnrTl = true;
    var track = root.querySelector('[data-tl-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-tl-card]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-tl-dot]'));
    var prev = root.querySelector('[data-tl-prev]');
    var next = root.querySelector('[data-tl-next]');
    var progress = root.querySelector('[data-tl-progress]');
    if (!track || !cards.length) return;

    function current() {
      var left = track.scrollLeft, best = 0, bestDist = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft - track.offsetLeft - left);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = cards.length - 1;
      return best;
    }
    function paint(i) {
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        d.classList.toggle('is-past', k < i);
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      if (progress && dots[i]) {
        var wrap = progress.parentNode.getBoundingClientRect();
        var dr = dots[i].getBoundingClientRect();
        progress.style.width = Math.max(0, dr.left - wrap.left + 8) + 'px';
      }
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === cards.length - 1;
    }
    function goTo(i) {
      i = Math.max(0, Math.min(cards.length - 1, i));
      track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft });
      paint(i);
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { paint(current()); });
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { goTo(k); }); });
    window.addEventListener('resize', function () { paint(current()); });

    /* mouse drag on desktop */
    var down = false, sx = 0, sl = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; sx = e.clientX; sl = track.scrollLeft; track.style.scrollSnapType = 'none'; track.style.scrollBehavior = 'auto';
    });
    window.addEventListener('pointermove', function (e) { if (down) track.scrollLeft = sl - (e.clientX - sx); });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false;
      track.style.scrollSnapType = ''; track.style.scrollBehavior = '';
      goTo(current());
    });

    paint(0);
  }

  function initAll(scope) {
    initAnimate(scope);
    (scope || document).querySelectorAll('[data-mnr-timeline]').forEach(initTimeline);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest && e.target.closest('[data-tl-card]');
    if (!card) return;
    var root = card.closest('[data-mnr-timeline]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-tl-card]'));
    var dot = root.querySelectorAll('[data-tl-dot]')[cards.indexOf(card)];
    if (dot) dot.click();
  });
})();
